'use client';

import React from 'react';
import { Search, X } from 'lucide-react';

interface PackageSearchBarProps {
  value: string;
  onChange: (val: string) => void;
}

export default function PackageSearchBar({ value, onChange }: PackageSearchBarProps) {
  return (
    <div className="relative flex-1">
      <Search size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <input
        type="text"
        className="input-field pl-10 pr-10 w-full"
        placeholder="Search by destination, package name, or highlight..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Clear search"
        >
          <X size={15} />
        </button>
      )}
    </div>
  );
}